var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filters_header"},[_c('div',{staticClass:"filters_header_left"},[_c('FiltersHeaderBackButton'),_c('div',{staticClass:"filters_header_title"},[_vm._v(" "+_vm._s(_vm.getTitle())+" ")])],1),_c('FiltersHeaderCloseButton',{staticClass:"close_btn"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }